const calcAnchorNavWidth = (has_resources, marketString, isMobile) => {
    // if in mobile, make container 100% and each link 100%
    if (isMobile) {
        return "100%";
    }
    // US site needs to be smaller so it accommodates search and cart items
    if (has_resources && marketString !== "DE") {
        return "130px";
    }
    // These instances have no search or cart, thus need to be bigger
    return "170px";
};

const preventDefault = (e) => {
    if (e.preventDefault) e.preventDefault();
    e.returnValue = false;
};

const disableScroll = () => {
    document.body.style.height = "100%";
    document.body.style.overflow = "hidden";
    window.ontouchmove = preventDefault;
};

const enableScroll = () => {
    document.body.style.height = "";
    document.body.style.overflow = "";
    window.ontouchmove = null;
};

const navigateTo = (destination, newWindow = false) => {
    if (newWindow) {
        const a = document.createElement("a");
        a.href = destination;
        a.target = "_blank";
        a.rel = "noopener";
        a.click();
    } else {
        window.location.href = destination;
    }
};

const queryStringToJson = (search) => {
    const pairs = search.slice(1).split("&");
    const result = {};
    pairs.forEach((pair) => {
        pair = pair.split("=");
        result[pair[0]] = decodeURIComponent(pair[1] || "");
    });

    return JSON.parse(JSON.stringify(result));
};

module.exports = { calcAnchorNavWidth, disableScroll, enableScroll, navigateTo, preventDefault, queryStringToJson };
